import React from 'react'
import { Link } from 'react-router-dom'

import { useIsMobile } from '@/shared/hooks/useIsMobile'

interface LoadingProps {
  padding?: string
}

export const Loading: React.FC<LoadingProps> = ({ padding = 'var(--space-100)' }) => (
  <div style={{ display: 'flex', justifyContent: 'center', padding }}>
    <div className="spinner" />
  </div>
)

interface ErrorViewProps {
  message: string
  onRetry?: () => void
}

export const ErrorView: React.FC<ErrorViewProps> = ({ message, onRetry }) => {
  const isMobile = useIsMobile()

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',
        padding: 'var(--space-2xl)',
        textAlign: 'center',
        gap: 'var(--space-xl)',
        color: 'var(--app-down)',
      }}
    >
      <div style={{ fontSize: isMobile ? 'var(--font-size-lg)' : 'var(--font-size-xl)', fontWeight: 'bold' }}>
        Something went wrong
      </div>
      <div
        style={{
          color: 'var(--app-text-secondary)',
          fontSize: isMobile ? 'var(--font-size-md)' : 'var(--font-size-lg)',
          maxWidth: 'var(--state-view-error-max-width)',
        }}
      >
        {message}
      </div>
      <div style={{ display: 'flex', gap: 'var(--space-lg)' }}>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            style={{
              backgroundColor: 'var(--brand-primary)',
              color: 'var(--brand-on-primary)',
              padding: isMobile ? 'var(--space-md) var(--space-xl)' : 'var(--space-md) var(--space-20)',
              borderRadius: 'var(--radius-md)',
              fontWeight: 'bold',
              fontSize: isMobile ? 'var(--font-size-md)' : undefined,
            }}
          >
            Retry
          </button>
        )}
        <Link
          to="/"
          style={{
            border: '1px solid var(--app-divider)',
            color: 'var(--app-text-primary)',
            padding: isMobile ? 'var(--space-md) var(--space-xl)' : 'var(--space-md) var(--space-20)',
            borderRadius: 'var(--radius-md)',
            textDecoration: 'none',
            fontSize: isMobile ? 'var(--font-size-md)' : undefined,
          }}
        >
          Back to Home
        </Link>
      </div>
    </div>
  )
}
